import { render, staticRenderFns } from "./VehicleModule.vue?vue&type=template&id=4370673e&scoped=true"
import script from "./VehicleModule.vue?vue&type=script&lang=ts"
export * from "./VehicleModule.vue?vue&type=script&lang=ts"
import style0 from "./VehicleModule.vue?vue&type=style&index=0&id=4370673e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4370673e",
  null
  
)

export default component.exports